import React, { useState, useEffect, useRef } from 'react';
import './CheckOTP.css';
import { useNavigate, useLocation } from 'react-router-dom';
import Modal from '../../components/Modal/Modal';

const API_URL = process.env.REACT_APP_API_URL;

const CheckOTP = () => {
    const [otp, setOtp] = useState(new Array(4).fill(''));
    const inputRefs = useRef([]);
    const [timer, setTimer] = useState(120);
    const [resendEnabled, setResendEnabled] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const username = location.state?.username;
    const [modalData, setModalData] = useState({
        isVisible: false,
        message: '',
        type: '',
    });

    useEffect(() => {
        const interval = setInterval(() => {
            setTimer((prev) => {
                if (prev > 0) return prev - 1;
                clearInterval(interval);
                setResendEnabled(true);
                return 0;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    const handleChange = (value, index) => {
        if (isNaN(value)) return;

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        if (value && index < otp.length - 1) {
            inputRefs.current[index + 1].focus();
        }
    };

    const handleBackspace = (index) => {
        if (otp[index] === '' && index > 0) {
            inputRefs.current[index - 1].focus();
        }
    };

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
    };

    const handleResend = async () => {
        if (!resendEnabled) return;

        setOtp(new Array(4).fill(''));
        setTimer(120);
        setResendEnabled(false);

        const body = {
            username: username,
            otp: otp.join(''),
        };

        try {
            const response = await fetch(`${API_URL}/accounts/send-otp`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            });
            if (response.ok) {
                setModalData({
                    isVisible: true,
                    message: 'کد با موفقیت ارسال شد',
                    type: 'success',
                });
            } else {
                const errorData = await response.json();
                setModalData({
                    isVisible: true,
                    message: errorData.error,
                    type: 'error',
                });
            }
        } catch (error) {
            setModalData({
                isVisible: true,
                message: 'مشکلی پیش آمده است. لطفا دوباره تلاش کنید',
                type: 'error',
            });
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const body = {
            username: username,
            otp: otp.join(''),
        };

        try {
            const response = await fetch(`${API_URL}/accounts/check-otp`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            });
            if (response.ok) {
                const data = await response.json();
                navigate('/restore-password', { state: { token: data.token } });
            } else {
                const errorData = await response.json();
                setModalData({
                    isVisible: true,
                    message: errorData.error,
                    type: 'error',
                });
            }
        } catch (error) {
            setModalData({
                isVisible: true,
                message: 'مشکلی پیش آمده است. لطفا دوباره تلاش کنید',
                type: 'error',
            });
        }
    };

    return (
        <div className="container">
            <div className="otp-box">
                <h2>تایید کد</h2>
                <form onSubmit={handleSubmit}>
                    <div className="otp-form">
                        {otp.map((value, index) => (
                            <input
                                key={index}
                                type="text"
                                maxLength="1"
                                value={value}
                                onChange={(e) => handleChange(e.target.value, index)}
                                onKeyDown={(e) => e.key === 'Backspace' && handleBackspace(index)}
                                ref={(el) => (inputRefs.current[index] = el)}
                                className="otp-input"
                            />
                        ))};
                    </div>
                    <button type="submit" className="submit-button btn">
                        تایید
                    </button>
                    <div className="timer">
                        {timer > 0 ? (
                            <div className="timer-wrapper">
                                <span>{formatTime(timer)}</span>
                            </div>
                        ) : (
                            <button
                                onClick={handleResend}
                                className={`resend-btn ${resendEnabled ? 'enabled' : 'disabled'} medium-text`}
                                disabled={!resendEnabled}
                            >
                                ارسال دوباره
                            </button>
                        )};
                    </div>
                </form>
                <Modal
                    message={modalData.message}
                    type={modalData.type}
                    isVisible={modalData.isVisible}
                    onClose={() => setModalData({ ...modalData, isVisible: false })}
                />
            </div>
        </div>
    );
};

export default CheckOTP;
